var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('svg', _vm._g({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "26",
      "height": "26"
    }
  }, _vm.$listeners), [_c('circle', {
    attrs: {
      "cx": "13",
      "cy": "13",
      "r": "13",
      "fill": "#fff"
    }
  }), _c('path', {
    attrs: {
      "fill": "#005149",
      "d": "m3.675 11.2 1.75 1.68c4.349-4.175 11.401-4.175 15.75 0l1.75-1.68c-5.311-5.099-13.93-5.099-19.25 0m7 6.72 2.625 2.52 2.625-2.52c-1.444-1.394-3.798-1.394-5.25 0m-3.5-3.36 1.75 1.68c2.415-2.318 6.335-2.318 8.75 0l1.75-1.68c-3.377-3.242-8.864-3.242-12.25 0"
    }
  })]);

}
var staticRenderFns = []

export { render, staticRenderFns }